import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import ErrorHandler from '@Root/ErrorHandler';
import { IoClose as Close, IoCheckmarkCircle as LiveIcon } from 'react-icons/io5';
import { ReactComponent as FormIcon } from '@Assets/form.svg';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import './LiveConnectionForm.scss';


export default function LiveConnectionForm(props) {

    const navigate = useNavigate();
    const [cursor, setCursor] = useState('auto');
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    const errorHandler = new ErrorHandler();
    const className = 'liveConnectionForm';

    const handleConfirm = async (e) => {
        e?.preventDefault();
        setCursor('wait');
        try {
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionConnectionLive(props.kaiziqResolveConnection.id, true);
            navigate(0);
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}>
            <div className={className + '__inner flex-column-flex-start'}>
                <div className={className + '__inner__titleBar width-wfa'}>
                    <div className={className + '__inner__titleBar__title flex-row-center-0p5rem-gap'}>
                        <div className={className + '__inner__titleBar__title__tag'}>
                            <FormIcon className={className + '__inner__titleBar__title__tag__icon grey-text'} />
                        </div>
                        <div className={className + '__inner__titleBar__title__t1 flex-row-flex-end standard-text-semi-large semi-bold-text'}>
                            <LiveIcon className={className + '__inner__titleBar__title__t1__icon'} />
                            Set Live
                        </div>
                    </div>
                    <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup} />
                </div>

                <div className={className + '__inner__name flex-column-flex-start'}>
                    <div className={className + '__inner__name__tag large-text'}>
                        {props.kaiziqResolveConnection?.title}
                    </div>
                </div>

                <form className={className + '__inner__form flex-column-flex-start width-wfa'} onSubmit={handleConfirm}>
                    <div className={className + '__inner__form__info flex-column-flex-start'}>
                        <div className={className + '__inner__form__info__t1'}>Are you sure you want to set this form to Live Mode?</div>
                        <div className={className + '__inner__form__info__t2 grey-text small-text'}>Users will be able to start making submissions. You won't be able to make further changes to the form fields.</div>
                    </div>
                    <div className={className + '__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                        <div className={className + '__inner__form__buttonFlex__confirm width-wfa'}>
                            <BorderBlueButtonV2
                                text='Confirm'
                                onClick={handleConfirm}
                                disabled={cursor === 'wait'} />
                        </div>
                        <div className={className + '__inner__form__buttonFlex__cancel width-wfa'}>
                            <BorderWhiteButtonV2
                                text='Cancel'
                                onClick={props.closePopup}
                                disabled={cursor === 'wait'} />
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
